import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QRCard = ({ showWhen, value }) => {
    if (showWhen) {
        return (
            <>
                <div className="font-sans text-2xl font-light flex justify-center items-center text-[#191C20]">
                    Open “Scan To Login” app on your <br />wearable and scan the QR code below.
                </div>

                <div className="w-[350px] h-[350px] qr-card bg-white rounded-2xl flex justify-center items-center">
                    <QRCodeCanvas size={280} value={value} />
                </div>
            </>
        );
    }
    return null;
};

export default QRCard;